import loadjs from 'loadjs';
import { jsNotifyAsDynamic } from '../components/common/ErrorBoundary/logger_new';
import { getChannelId } from '../services/HttpService';
import { getCookie } from '../components/common/Helpers';

export const polymapScript = () =>
  window?.location?.href?.indexOf('localhost') !== -1
    ? `${window?.location?.origin}/polymaplib.js`
    : `${window?.location?.origin}/etc/clientlibs/vcg/digital/soe-digital-nextgen/static/js/polymaplib.js`;

export const isPolymapEnabled = () => window.vzFlags?.isPolymapEnabled || false;

const options = {};
export const loadPolymapScript = (page) => {
  try {
    loadjs(polymapScript(), 'polymap', { returnPromise: true })
      .then(() => {
        const clickselector = [];
        const selector1 = {};
        selector1.attr = 'data-track,aria-controls,data-testid,data-track-detail,aria-label,data-filter,id';
        clickselector.push(selector1);
        options.clickselectors = clickselector;
        options.selectors = selectorsList[page]?.selectorObj; // pass the selectors array
        options.polySize = 200; // size of the polymapvfr window
        options.poly_ypos = 50;
        options.distanceMetrics = true; // will get the elements away from the current region
        /* append to root dom element of the application or can keep it null */
        options.appendToWindowElement = document.getElementById('root');
        options.maxstackelements = 10; // stack size is reaching more than 50
        options.inactivetimeout = 30; // fire on inactive if the user goes away from the current window or any other window
        options.cutoftime = 50; // fire on cut oftime where even if the user does not perform any action
        options.callBack = loggingCallback;
        const crypto = window.crypto || window.msCrypto;
        options.sessionID =
          sessionStorage.getItem('psessionID') != null
            ? sessionStorage.getItem('psessionID')
            : new Date().valueOf() + crypto.getRandomValues(new Uint32Array(1))[0]; // pass the unique id of the user
        sessionStorage.setItem('psessionID', options.sessionID);
        options.poly_xpos = 0;
        options.isDebug = false; // make it false while pushing to QA
        options.zIndex = -1; // zindex at polymapvfr should be loaded at inside the window
        options.isWindowScroll = true;
        options.showAnalytics = false;
        window.initPolyMap(options); // call polymap method to process page insights
      })
      .catch((error) => {
        console.debug(error);
      });
  } catch (e) {
    console.debug('There is an issue with polymap', e);
  }
};

const selectorsList = {
  progressivePlans: {
    selectorObj: [
      {
        selectorCondition:
          'h1,h2,h3,h4,h5,h6,a,button[aria-label],li,p[data-testid],div[data-testid],div[aria-label],div[data-track],p[data-track],p[aria-hidden],p[small]',
      },
    ],
    clickselectorObj: [],
  },
};
const app_sessionid = options.sessionID;
export const loggingCallback = (loggingArr, polymapinsightParam, currentviewregion, typeofcallback, scannedelements) => {
  console.log('scannedelements->', scannedelements);

  const polymapinsight = polymapinsightParam;
  if (polymapinsight) {
    polymapinsight.polyid = app_sessionid;
  }
  if (!(typeofcallback.includes('waitTime') || typeofcallback.includes('hover') || typeofcallback.includes('windowClick'))) {
    if (!typeofcallback.includes('locationchange')) {
      if (
        loggingArr.length > 0 &&
        loggingArr?.[loggingArr.length - 1] !== undefined &&
        loggingArr?.[loggingArr.length - 1] &&
        loggingArr?.[loggingArr.length - 1]?.polymap?.currentregion !== '__'
      ) {
        polymapinsight.currentRegion = loggingArr?.[loggingArr.length - 1]?.polymap?.currentregion;
      } else if (
        loggingArr.length > 1 &&
        loggingArr?.[loggingArr.length - 2] !== undefined &&
        loggingArr?.[loggingArr.length - 2] &&
        loggingArr?.[loggingArr.length - 2]?.polymap?.currentregion !== '__'
      ) {
        polymapinsight.currentRegion = loggingArr?.[loggingArr.length - 2]?.polymap?.currentregion;
      }
    } else {
      polymapinsight.currentRegion = '';
    }
    polymapinsight.userid = getCookie('digital_ig_session');
    polymapinsight.appid = getChannelId();
    const requestData = {
      messageType: 'Polymap',
      message: typeofcallback,
      loggerMessage: {
        polymapinsight,
        typeofcallback,
        loggingArr,
      },
    };
    jsNotifyAsDynamic(requestData);
  }
};
